<form class="wrapper" [formGroup]="form">
    <div class="dropdown-container" #formWrapper>
        <cap-dropdown [appendTo]="formWrapper"
                      [options]="regionOptions$ | async"
                      [sortAlphabetically]="false"
                      label="{{'dashboard-rmc.dashboard-reports.school-year.label' | translate}}"
                      formControlName="regionYear">
        </cap-dropdown>
    </div>

    <div class="button-wrapper">
        <button [disabled]="disabledSubmit" class="download-button"  [class.disabled]="disabledSubmit" (click)="onSubmit()">
            <i [class]="downloadIcon"></i>
            <span>{{'dashboard-rmc.dashboard-reports.analysis-download.label' | translate}}</span>
        </button>
    </div>
</form>

